import { makeStyles } from '@material-ui/core/styles';

export const useDashboardStyles = makeStyles((theme) => ({
  boxContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  cardHeader: {
    backgroundColor: '#0087B6',
    color: 'white',
    padding: '10px 20px',
    width: '100%',
    boxSizing: 'border-box',
    margin: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    transition: 'all 0.5s ease',
    '& .MuiCardHeader-title': {
      color: 'white',
      fontWeight: 400,
      fontSize: '1.25rem',
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      overflow: 'visible',
      '& .MuiTypography-subtitle2': {
        marginLeft: '4px',
        fontSize: '0.7rem',
        opacity: 0.8,
        color: 'white'
      }
    },
    '& .MuiCardHeader-subheader': {
      color: 'rgba(255, 255, 255, 0.7)'
    },
    '& .MuiCardHeader-content': {
      width: 'auto',
      overflow: 'hidden',
      color: 'white'
    }
  },
  cardHeaderCollapsed: {
    backgroundColor: 'transparent',
    padding: 0,
    height: '100%',
    width: '100%',
    boxSizing: 'border-box',
    margin: 0,
    maxWidth: '100%',
    overflow: 'visible',
    transition: 'all 0.5s ease',
    '& .MuiCardHeader-title': {
      color: 'white',
      fontWeight: 500,
      fontSize: '1.5rem',
      transform: 'rotate(-90deg)',
      whiteSpace: 'nowrap',
      overflow: 'visible'
    },
    '& .MuiCardHeader-subheader': {
      color: 'rgba(255, 255, 255, 0.7)'
    },
    '& .MuiCardHeader-content': {
      width: '100%',
      overflow: 'visible',
      color: 'white'
    }
  },
  card: {
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    borderRadius: '10px',
    height: '350px',
    maxHeight: '350px',
    minHeight: '350px',
    overflow: 'hidden',
    backgroundColor: 'white',
    width: '100%',
    position: 'relative',
    maxWidth: '100%'
  },
  cardCollapsed: {
    backgroundColor: '#0087B6',
    boxShadow: 'none',
    minWidth: '80px'
  },
  cardExpanded: {
    // Remove conflicting width/flex properties - let container handle sizing
  },
  expandIcon: {
    color: '#0087B6',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '50%',
    padding: '6px',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.5)'
    }
  },
  expandIconCollapsed: {
    color: 'white',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.5)'
    }
  },
  exitIcon: {
    color: 'white',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '50%',
    padding: '6px',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.5)'
    }
  }
}));